import PropTypes from 'prop-types';
import dayjs from '../../utils/dayjs';
import {
  toolIsManuallyGraded,
  isLearningCurve,
} from '@macmillan-learning/gradebook-shared';

import s from './DateCompleted.module.css';

const DateCompleted = ({ assignment }) => {
  const dateFormat = 'MMM. D, YYYY h:mm a';
  const {
    tool,
    subtype,
    dateCompleted,
    receivedLatePenalty,
    isInstructorEntered,
  } = assignment;
  const isLearningCurveAssignment = isLearningCurve(tool);

  const conditionallyRenderTag = () => {
    if (isInstructorEntered || toolIsManuallyGraded(tool, subtype)) {
      return (
        <span
          className={s.dateContent}
          data-test-id={`${assignment.name}-override`}
        >
          <br />
          instructor entered
        </span>
      );
    } else if (receivedLatePenalty) {
      return (
        <span className={s.lateDate} data-test-id={`${assignment.name}-late`}>
          LATE
        </span>
      );
    }
    return null;
  };

  return (
    <div>
      {dateCompleted && !isLearningCurveAssignment && (
        <div
          className={s.dateCompleted}
          data-test-id={`${assignment.name}-date-completed`}
        >
          Date Completed:&nbsp;
          <span className={s.dateContent}>
            {dayjs(dateCompleted).format(dateFormat)}
          </span>
          {conditionallyRenderTag()}
        </div>
      )}
      {dateCompleted && isLearningCurveAssignment && (
        <div className={s.dateCompleted}>
          <span data-test-id={`${assignment.name}-target-reached`}>
            Target Score Reached:&nbsp;
            <span className={s.dateContent}>
              {dayjs(dateCompleted).format(dateFormat)}
            </span>
          </span>
          {conditionallyRenderTag()}
        </div>
      )}
    </div>
  );
};

DateCompleted.propTypes = {
  assignment: PropTypes.object.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  gradingType: PropTypes.number,
};

export default DateCompleted;
